<template>
  <div class="row inline items-center full-width">
    <QTooltip
      v-if="!opened && toolTip"
      anchor="top left"
      self="bottom left"
      :offset="[0, 0]"
    >
      {{ toolTip }}
    </QTooltip>
    <SAICheckbox
      class="q-mr-xs"
      :value="accepted"
      @input="$emit('accept', $event)"
      :val="true"
      :label="checkboxLabel"
      :disable="!opened"
    />
    <SAILink
      class="cursor-pointer text-weight-medium"
      :label="linkLabel"
      :disable="loading"
      @click="$emit('open')"
    />
    <span v-if="suffix">{{ suffix }}</span>
    <SAISpinner v-if="loading" size="16px" class="q-ml-xs" />
  </div>
</template>

<script>
import { QTooltip } from 'quasar';
import { SAILink, SAICheckbox, SAISpinner } from 'ecx.saigon.ui.common';

export default {
  name: 'QuoteAcceptanceCopyPrivacy',
  props: {
    loading: Boolean,
    opened: Boolean,
    accepted: Boolean,
    toolTip: String,
    checkboxLabel: {
      type: String,
      required: true
    },
    linkLabel: {
      type: String,
      required: true
    },
    suffix: String
  },
  components: {
    SAILink,
    QTooltip,
    SAICheckbox,
    SAISpinner
  }
};
</script>
